import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import React from 'react';
import {FlatList, ListRenderItemInfo, View} from 'react-native';
import {TranscriptionChatData} from 'services/API/ClassApi/ClassApiModels';
import TranscriptionsChatListCell from '../transcriptionsChatListCell';
import styleSheet from './styles';

export interface TranscriptionsChatListProps {
  flatListData: TranscriptionChatData[];
}

const TranscriptionsChatList = observer(
  (props: TranscriptionsChatListProps) => {
    const theme = useTheme();
    const styles = styleSheet(theme);

    const renderItem = (
      itemProps: ListRenderItemInfo<TranscriptionChatData>,
    ) => {
      return <TranscriptionsChatListCell itemProps={itemProps} />;
    };

    return (
      <View style={styles.container}>
        <FlatList
          style={styles.flatList}
          renderItem={renderItem}
          scrollEnabled={true}
          data={props.flatListData}
          keyExtractor={(item, index) =>
            `${item.firstName} ${item.lastName} ${index}`
          }
        />
      </View>
    );
  },
);

export default TranscriptionsChatList;
